import React from "react";

const AlertTemplate = ({message, options}) => (
    <div
        className="  lg:text-shadow-lg  rounded p-2 shadow-inner "
        style={{
            background: "white", fontSize: "22px", broderRadius: '4px', textAlign: 'center'
            , boxShadow: 'rgb(38 57 77) 0px 4px 26px -1px'
            , width: 'auto'
        }}
    >
        {Object.keys(message).map(key => {
            const type = message[key].type;
            const msg = message[key].msg;
            return (
                <React.Fragment>
                    <div
                        key={key}
                        style={{
                            display: 'inline-flex', broderRadius: '4px', whiteSpace: 'nowrap'
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke={type === "success" ? '#31B404' : (type === "error" ? 'red' : 'blue')}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            style={{marginRight: "8px", minWidth: "24px", marginTop: "1px"}}
                        >
                            {type === "success" && (
                                <React.Fragment>
                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                </React.Fragment>
                            )}
                            {type === "error" && (
                                <React.Fragment>
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="8" x2="12" y2="12"></line>
                                    <line x1="12" y1="16" x2="12" y2="16"></line>
                                </React.Fragment>
                            )}
                            {type === "info" && (
                                <React.Fragment>
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="16" x2="12" y2="12"></line>
                                    <line x1="12" y1="8" x2="12" y2="8"></line>
                                </React.Fragment>
                            )}   </svg>
                        <div>
                            {msg}
                        </div>
                    </div>
                    <br></br>
                </React.Fragment>
            )
        })}
    </div>
);
export default AlertTemplate;